import { useLocale } from '../hooks/useLocale.jsx';

// "방 하나 보기" (plan_room) — 2.4.0 에서는 숨긴다. 눈높이 사진의 문·창·가구 정확도가 절반 수준이라
// (ROADMAP 4번). 서버·결과 화면은 그대로 두어 이미 만든 디자인은 보이고, true 로 바꾸면 다시 켜진다.
export const PLAN_ROOM_ENABLED = false;

// 평면도에서 고른 방 (outputType 'plan_room') — 눈높이 사진과 평면도는 비율도 시점도 달라서
// before/after 슬라이더 대신 결과 한 장 + 어느 방을 골랐는지 작은 평면도.
export function PlanRoomResult({ src, planSrc, alt }) {
  const { t } = useLocale();
  return (
    <figure className="plan-room-result">
      <img src={src} alt={alt} className="preview-image" />
      {planSrc && (
        <figcaption className="plan-room-from">
          <img src={planSrc} alt="" loading="lazy" />
          <span>{t('planRoomFrom')}</span>
        </figcaption>
      )}
    </figure>
  );
}

// 슬라이더 양쪽 이름 — 평면도 결과는 "원본 / AI 디자인" 대신 무엇을 만들었는지.
export function planSliderLabels(t, outputType) {
  return outputType
    ? { before: t('planInputLabel'), after: t(`planOutput_${outputType}`) }
    : { before: t('original'), after: t('aiDesign') };
}

// 다시 만들기 — 같은 평면도 모드로 돌아가게 만들기 화면 prefill 을 채운다.
export function planPrefill(design) {
  const v = design.outputType;
  if (!v) return null;
  return {
    style: 'floorplan',
    planVariant: v === 'plan_3d' ? '3d' : v === 'plan_room' ? (PLAN_ROOM_ENABLED ? 'room' : '3d') : 'clean',
    planCleanKind: v === 'plan_color' ? 'color' : 'line',
    ...(design.style && design.style !== 'floorplan' && { planStyle: design.style }),
  };
}
